import DropOffStore from './DropOffStore';
import { withI18n } from 'react-i18next';

export default withI18n()(DropOffStore);
